import { render, staticRenderFns } from "./TempoProcessamentoArea.vue?vue&type=template&id=57ac319f&scoped=true&"
import script from "./TempoProcessamentoArea.vue?vue&type=script&lang=js&"
export * from "./TempoProcessamentoArea.vue?vue&type=script&lang=js&"
import style0 from "./TempoProcessamentoArea.vue?vue&type=style&index=0&id=57ac319f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac319f",
  null
  
)

export default component.exports